<template>
  <div class="view__view view-delivery">
    <div class="view__headline">
      <span class="heading beta -color-white">Bitte Zustelltag auswählen</span>
    </div>
    <div class="view__form form days__selection">
      <template v-for="(days) in deliveries.getDays" :key="days.id">
        <template v-for="(day) in days.schedule" :key="day.id">
          <label :for="'day-' + days.id"
                 :class="{'-filled': locations.selectedLocationId === days.id}">
            <input type="radio" :id="'day-' + days.id" name="day"
                   :value="days.id" v-model="locations.selectedLocationId">
            <span class="heading beta -color-white" v-if="day === 'monday'">MO</span>
            <span class="heading beta -color-white" v-if="day === 'tuesday'">DI</span>
            <span class="heading beta -color-white" v-if="day === 'wednesday'">MI</span>
            <span class="heading beta -color-white" v-if="day === 'thursday'">DO</span>
            <span class="heading beta -color-white" v-if="day === 'friday'">FR</span>
            <span class="heading beta -color-white" v-if="day === 'saturday'">SA</span>
            <span class="heading beta -color-white" v-if="day === 'sunday'">SO</span>
          </label>
        </template>
      </template>
    </div>
    <div class="view__headline">
      <span class="heading beta -color-white">Bitte betroffene Zustellung auswählen</span>
    </div>
    <div class="view__form form delivery__selection">
      <template v-for="(delivery) in deliveries.getDeliveries" :key="delivery.id">
        <label :for="'delivery-' + delivery.id"
               :class="{'-filled': locations.selectedLocationId === delivery.id}">
          <input type="radio" :id="'delivery-' + delivery.id" name="delivery"
                 :value="delivery.id" v-model="locations.selectedLocationId">
          <img v-if="delivery.productIdentifier === 1701"
               src="../assets/amperbote.jpg"
               alt="Amper Bote">
          <img v-else-if="
          delivery.productIdentifier === 1893 ||
          delivery.productIdentifier === 1871 ||
          delivery.productIdentifier === 1890 ||
          delivery.productIdentifier === 1897 ||
          delivery.productIdentifier === 1888 ||
          delivery.productIdentifier === 1873 ||
          delivery.productIdentifier === 1881 ||
          delivery.productIdentifier === 1895 ||
          delivery.productIdentifier === 1887 ||
          delivery.productIdentifier === 1891 ||
          delivery.productIdentifier === 1894 ||
          delivery.productIdentifier === 1872 ||
          delivery.productIdentifier === 1880 ||
          delivery.productIdentifier === 1883"
              src="../assets/prospekte.jpg"
              alt="Prospekte">
          <img v-else-if="delivery.productIdentifier === 1711"
               src="../assets/lanshuter-wochenblatt.jpg"
               alt="Lanshuter Wochenblatt">
          <img v-else-if="delivery.productIdentifier === 1724"
               src="../assets/straubinger-wochenblatt.jpg"
               alt="Straubinger Wochenblatt">
          <img v-else-if="delivery.productIdentifier === 1712"
               src="../assets/isar-wochenblatt.jpg"
               alt="Isar Wochenblatt">
          <img v-else-if="delivery.productIdentifier === 1743"
               src="../assets/chg-wochenblatt.jpg"
               alt="Chiemgau Wochenblatt">
          <span v-else>{{ delivery.reference }}</span>
        </label>
      </template>
      <div class="placeholder"></div>
      <div class="placeholder"></div>
    </div>
    <div class="cta-wrapper">
      <button class="-btn-beta" @click="handleSubmit"><span>Nächster Schritt</span></button>
    </div>
  </div>
</template>

<script>
import { useViewStore } from '@/stores/view';
import { useDeliveryStore } from '@/stores/delivery';
import { useLocationStore } from '@/stores/location';

export default {
  name: 'NameEntry',
  methods: {
    handleSubmit() {
      if (this.locations.selectedLocationId) {
        this.locations.userLocation = this.locations
          .getLocationById(this.locations.selectedLocationId);
        this.view.update('PrivacyEntry', this.view.counter + 1);
      }
    },
  },
  setup() {
    const locations = useLocationStore();
    const deliveries = useDeliveryStore();
    const view = useViewStore();
    deliveries.getDeliveriesAndDays(
      locations.selectedLocation,
    );
    return {
      view,
      locations,
      deliveries,
    };
  },
};
</script>
